import { useEffect } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import { handleTinuitiCookie, trackTinuitiPageView } from '@alltrails/core/utils/tinuitiUtils';

const DEFER_ANALYTICS_MS = 500;

const useTinuitiPixel = () => {
  const user = useUser();
  const userId = user?.id?.toString();

  useEffect(() => {
    const runAfterFirstPaint = () => {
      handleTinuitiCookie();
      trackTinuitiPageView(userId);
    };

    if (typeof requestIdleCallback !== 'undefined') {
      const id = requestIdleCallback(runAfterFirstPaint, { timeout: DEFER_ANALYTICS_MS });
      return () => cancelIdleCallback(id);
    } else {
      const id = setTimeout(runAfterFirstPaint, DEFER_ANALYTICS_MS);
      return () => clearTimeout(id);
    }
  }, [userId]);
};

export default useTinuitiPixel;
